import request from '@/utils/request'

// 查询客户列表
export function listUser(query) {
    return request({
        url: '/biz/user/list',
        method: 'get',
        params: query
    })
}

// 查询客户列表
export function searchListUser(query) {
    return request({
        url: '/biz/user/searchListUser',
        method: 'get',
        params: query
    })
}
// 查询客户列表
export function searchListUserAllinfo(query) {
    return request({
        url: '/biz/user/searchListUserAllinfoIdNumber',
        method: 'get',
        params: query
    })
}

// 查询客户列表
export function searchListUserOfficer(query) {
    return request({
        url: '/biz/user/searchListUserOfficer',
        method: 'get',
        params: query
    })
}

// 查询客户详细
export function getUser(id) {
    return request({
        url: '/biz/user/' + id,
        method: 'get'
    })
}

// 新增客户
export function addUser(data) {
    return request({
        url: '/biz/user',
        method: 'post',
        data: data
    })
}

// 修改客户
export function updateUser(data) {
    return request({
        url: '/biz/user/update',
        method: 'post',
        data: data
    })
}
// 拉去数据
export function refreshUserAllHisRequest(id) {
    return request({
        url: '/biz/user/refreshUserAllHisRequest/' + id,
        method: 'post'
    })
}



// 删除客户
export function delUser(id) {
    return request({
        url: '/biz/user/delete/' + id,
        method: 'post'
    })
}
